<div class="btn-group">
    <button mat-button mat-dialog-close (click)="method('paypal')" *ngIf="guiService.userLogged.userPaymentInfo.paymentType == 'PAYPAL'">Paypal</button>
    <button mat-button cdkFocusInitial (click)="method('card')" *ngIf="guiService.userLogged.userPaymentInfo.paymentType == 'STRIPE'">{{"REGISTER.CREDIT_CARD.CARD" | translate}}</button>
</div>
